export const HISTORY_ENTITY_TYPES = [
	'GoogleAdsTemplate',
	'FacebookTemplate',
	'GMBTemplate',
] as const;

export type HistoryEntityType = (typeof HISTORY_ENTITY_TYPES)[number];

export const HISTORY_ACTION_TYPES = [
	'CREATE',
	'UPDATE',
	'DELETE',
	'UPLOAD',
] as const;
